import type {Entitlement} from '../model';
import {EntitlementsModules} from '../model';

export type ClientEntitlements = keyof typeof EntitlementsModules;

export const isEntitled = (
  entitlements: Entitlement[],
  module: ClientEntitlements
): boolean => {
  return entitlements.some(e => e.key === module.valueOf() && e.enabled);
};
